/**
 * Walk Paths
 * ------
 */

if($("#path-graphic").length) {

    // var path = document.querySelector('.path');
    // var length = path.getTotalLength();

    let pathGraphicContainer = $('#path-graphic'),
        path = pathGraphicContainer.find('path'),
        pathLength = path[0].getTotalLength();

    path.not('.dashed').css('stroke-dasharray', pathLength);
    path.not('.dashed').css('stroke-dashoffset', pathLength);
    // path.not('.dashed').addClass('activated');

    $('body').imagesLoaded(function () {
        let containerSize = pathGraphicContainer.actual('height');

        // console.log(containerSize);

        $(window).on('scroll', function () {
            let offsetAmount = 500;
            if($(window).width() < 1400) {
                offsetAmount = 400;
            } else if($(window).width() < 1300) {
                offsetAmount = 200;
            }

            let scrollPercentage = ($(window).scrollTop() - offsetAmount) / containerSize;

            // console.log('-------');
            // console.log(scrollPercentage);
            // console.log(pathLength - (pathLength * scrollPercentage));

            // path.not('.dashed').css('stroke-dasharray', pathLength - (pathLength * scrollPercentage));
            path.not('.dashed').css('stroke-dashoffset', (pathLength - (pathLength * scrollPercentage)));

        });
    });



    // let pathGraphicHero =

}